import type {MockActivity} from "../../types";
import {days} from "./evidence";

export const PROCESS_ACTIVITY: Record<string, MockActivity[]> = {
  "proc-vendor-invoice": [
    {id: "act-vi-01", user: "Jenny Zhan", description: "changed status to In Review", timestamp: days(1)},
    {
      id: "act-vi-02",
      user: "James Evans",
      description: "commented",
      body: "Three-way match evidence looks good. The SAP screenshot clearly shows the validation gate. Moving to reviewer sign-off.",
      timestamp: days(2),
    },
    {
      id: "act-vi-03",
      user: "Jenny Zhan",
      description: 'added evidence "Purchasing Policy Manual v2.3"',
      timestamp: days(4),
    },
    {
      id: "act-vi-04",
      user: "Jenny Zhan",
      description: 'added evidence "AP-04 Three-Way Match Screenshot"',
      timestamp: days(4),
    },
    {id: "act-vi-05", user: "Phoebe Scott", description: "signed off as Preparer", timestamp: days(6)},
    {id: "act-vi-06", user: "Jenny Zhan", description: "changed status to In Progress", timestamp: days(10)},
  ],
  "proc-order-fulfillment": [
    {
      id: "act-of-01",
      user: "Phoebe Scott",
      description: "commented",
      body: "Need to verify the billing trigger configuration with the Warehouse team before we can sign off on AR-04.",
      timestamp: days(1),
    },
    {
      id: "act-of-02",
      user: "James Evans",
      description: 'added evidence "Billing System Walkthrough Recording"',
      timestamp: days(3),
    },
    {id: "act-of-03", user: "Phoebe Scott", description: "changed status to In Review", timestamp: days(3)},
    {
      id: "act-of-04",
      user: "James Evans",
      description: 'added evidence "Revenue Recognition Policy"',
      timestamp: days(7),
    },
    {id: "act-of-05", user: "Phoebe Scott", description: "signed off as Preparer", timestamp: days(9)},
    {
      id: "act-of-06",
      user: "James Evans",
      description: "commented",
      body: "Starting walkthrough documentation for the O2C billing trigger. Will upload the recording once complete.",
      timestamp: days(12),
    },
    {id: "act-of-07", user: "Phoebe Scott", description: "changed status to In Progress", timestamp: days(14)},
  ],
  "proc-journal-entry": [
    {
      id: "act-je-01",
      user: "Jenny Zhan",
      description: "commented",
      body: "Controller confirmed the period close restrictions are enforced system-wide. Adding the SAP configuration screenshot as evidence.",
      timestamp: days(0),
    },
    {
      id: "act-je-02",
      user: "Jenny Zhan",
      description: 'added evidence "SAP Period Close Configuration"',
      timestamp: days(1),
    },
    {id: "act-je-03", user: "Henry Irish", description: "signed off as Reviewer", timestamp: days(2)},
    {id: "act-je-04", user: "Jenny Zhan", description: "changed status to In Review", timestamp: days(3)},
    {id: "act-je-05", user: "Jenny Zhan", description: 'added evidence "Journal Entry Policy"', timestamp: days(5)},
    {
      id: "act-je-06",
      user: "Henry Irish",
      description: "commented",
      body: "Reviewed the dual approval evidence. JE-01 control documentation is comprehensive. Proceeding with sign-off.",
      timestamp: days(7),
    },
    {
      id: "act-je-07",
      user: "Jenny Zhan",
      description: 'added evidence "JE-01 Control Testing Questionnaire"',
      timestamp: days(8),
    },
    {id: "act-je-08", user: "Jenny Zhan", description: "changed status to In Progress", timestamp: days(11)},
  ],
};

export const FSA_ACTIVITY: Record<string, MockActivity[]> = {
  expenditures: [
    {id: "act-fsa-exp-01", user: "Jenny Zhan", description: "changed status to In Review", timestamp: days(1)},
    {
      id: "act-fsa-exp-02",
      user: "James Evans",
      description: "commented",
      body: "Scoping complete — all COTABDs mapped to assertions. Moving risk assessment to review.",
      timestamp: days(3),
    },
    {
      id: "act-fsa-exp-03",
      user: "Jenny Zhan",
      description: 'added evidence "Expenditure Cycle Walkthrough Notes"',
      timestamp: days(5),
    },
    {id: "act-fsa-exp-04", user: "Phoebe Scott", description: "changed status to In Progress", timestamp: days(8)},
  ],
  revenue: [
    {id: "act-fsa-rev-01", user: "Phoebe Scott", description: "changed status to Locked", timestamp: days(0)},
    {
      id: "act-fsa-rev-02",
      user: "Jenny Zhan",
      description: "commented",
      body: "Revenue recognition risk assessment finalized. All significant COTABDs linked to processes.",
      timestamp: days(2),
    },
    {
      id: "act-fsa-rev-03",
      user: "Phoebe Scott",
      description: 'added evidence "Revenue Cycle Risk Matrix"',
      timestamp: days(4),
    },
    {id: "act-fsa-rev-04", user: "James Evans", description: "signed off as Preparer", timestamp: days(6)},
    {id: "act-fsa-rev-05", user: "Phoebe Scott", description: "changed status to In Review", timestamp: days(9)},
  ],
  "financial-reporting": [
    {id: "act-fsa-fr-01", user: "Jenny Zhan", description: "changed status to In Review", timestamp: days(1)},
    {
      id: "act-fsa-fr-02",
      user: "Henry Irish",
      description: "commented",
      body: "Need to confirm disclosure COTABDs with the reporting team before scoping sign-off.",
      timestamp: days(3),
    },
    {
      id: "act-fsa-fr-03",
      user: "Jenny Zhan",
      description: 'added evidence "Financial Reporting Process Map"',
      timestamp: days(6),
    },
  ],
};

export const ELC_ACTIVITY: Record<string, MockActivity[]> = {
  "elc-control-environment": [
    {id: "act-ce-01", user: "Jenny Zhan", description: "changed status to Locked", timestamp: days(2)},
    {
      id: "act-ce-02",
      user: "Jenny Zhan",
      description: "commented",
      body: "Board oversight walkthrough completed. Audit committee charter and reporting package both confirmed. Minutes documentation needs improvement — adding finding.",
      timestamp: days(4),
    },
    {id: "act-ce-03", user: "Phoebe Scott", description: 'added evidence "Code of Conduct v4.0"', timestamp: days(5)},
    {
      id: "act-ce-04",
      user: "Phoebe Scott",
      description: 'added evidence "Annual Ethics Training Completion Report"',
      timestamp: days(5),
    },
    {
      id: "act-ce-05",
      user: "Jenny Zhan",
      description: 'added evidence "Audit Committee Charter (2026)"',
      timestamp: days(7),
    },
    {
      id: "act-ce-06",
      user: "Jenny Zhan",
      description: 'added evidence "Q3 2025 Audit Committee Meeting Minutes"',
      timestamp: days(9),
    },
  ],
  "elc-monitoring-governance": [
    {id: "act-moc-01", user: "Jenny Zhan", description: "changed status to In Progress", timestamp: days(1)},
    {
      id: "act-moc-02",
      user: "Phoebe Scott",
      description: "commented",
      body: "KPI dashboard review completed for February. Exception volumes within normal range but noted the monitoring rules haven't been updated since January 2025.",
      timestamp: days(3),
    },
    {
      id: "act-moc-03",
      user: "Jenny Zhan",
      description: 'added evidence "Monthly KPI Dashboard — February 2026"',
      timestamp: days(4),
    },
    {
      id: "act-moc-04",
      user: "Phoebe Scott",
      description: 'added evidence "Deficiency Tracker Export — February 2026"',
      timestamp: days(5),
    },
    {
      id: "act-moc-05",
      user: "Henry Irish",
      description: "commented",
      body: "SOC 1 report for the payroll provider received. Reviewing complementary user entity controls before marking the outsourced monitoring assessment as complete.",
      timestamp: days(7),
    },
    {
      id: "act-moc-06",
      user: "Henry Irish",
      description: 'added evidence "SOC 1 Type II Report — Cloud Payroll Provider"',
      timestamp: days(8),
    },
    {
      id: "act-moc-07",
      user: "Jenny Zhan",
      description: 'added evidence "Internal Audit Annual Plan (2026)"',
      timestamp: days(10),
    },
  ],
  "elc-risk-assessment": [
    {id: "act-ra-01", user: "Jenny Zhan", description: "changed status to In Progress", timestamp: days(1)},
    {
      id: "act-ra-02",
      user: "Phoebe Scott",
      description: "commented",
      body: "Risk register reviewed against financial reporting assertions. Six business risks mapped — two remain open without full mitigation plans.",
      timestamp: days(3),
    },
    {
      id: "act-ra-03",
      user: "Jenny Zhan",
      description: 'added evidence "Enterprise Risk Register — Q1 2026"',
      timestamp: days(4),
    },
    {
      id: "act-ra-04",
      user: "Phoebe Scott",
      description: 'added evidence "Risk Management Policy v2.1"',
      timestamp: days(6),
    },
    {
      id: "act-ra-05",
      user: "Jenny Zhan",
      description: "commented",
      body: "Change assessment completed. Three of five significant changes not fully addressed — WMS migration and acquisition integration controls still pending.",
      timestamp: days(8),
    },
  ],
  "elc-it-environment": [
    {id: "act-gitc-01", user: "James Evans", description: "changed status to In Review", timestamp: days(1)},
    {
      id: "act-gitc-02",
      user: "Phoebe Scott",
      description: "commented",
      body: "Quarterly access review completed. Two exceptions identified — both related to contractor accounts that were not deprovisioned within SLA. Remediation tickets created.",
      timestamp: days(2),
    },
    {
      id: "act-gitc-03",
      user: "James Evans",
      description: 'added evidence "Quarterly Access Review Report — Q3 2025"',
      timestamp: days(3),
    },
    {
      id: "act-gitc-04",
      user: "James Evans",
      description: 'added evidence "IT Access Management Policy v3.1"',
      timestamp: days(5),
    },
    {id: "act-gitc-05", user: "Phoebe Scott", description: "signed off as Preparer", timestamp: days(7)},
    {
      id: "act-gitc-06",
      user: "James Evans",
      description: "commented",
      body: "Starting documentation of change management controls. Will schedule CAB process walkthrough with the release management team.",
      timestamp: days(10),
    },
    {id: "act-gitc-07", user: "Phoebe Scott", description: "changed status to In Progress", timestamp: days(14)},
  ],
};
